module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '3mpqhwaw',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
